module.exports = __webpack_public_path__ + "img/uitx.8ed8be32.svg";